/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchAdminDto } from '../models/BranchAdminDto';
import type { BranchClientDto } from '../models/BranchClientDto';
import type { BranchDriverDto } from '../models/BranchDriverDto';
import type { BranchStatus } from '../models/BranchStatus';
import type { ExportAdminResponse } from '../models/ExportAdminResponse';
import type { GenericZohoValuesAdminDto } from '../models/GenericZohoValuesAdminDto';
import type { GetBranchBranchTagsAdminResponse } from '../models/GetBranchBranchTagsAdminResponse';
import type { GetBranchConfigurationsResponse } from '../models/GetBranchConfigurationsResponse';
import type { GetBranchDistrictsAdminResponse } from '../models/GetBranchDistrictsAdminResponse';
import type { GetBranchesClientOptions } from '../models/GetBranchesClientOptions';
import type { GetBranchesClientPublicOptionsClient } from '../models/GetBranchesClientPublicOptionsClient';
import type { GetBranchShiftsClientResponse } from '../models/GetBranchShiftsClientResponse';
import type { GetBranchStatusResponse } from '../models/GetBranchStatusResponse';
import type { GetMinimumCartAmountToOrderResponseClient } from '../models/GetMinimumCartAmountToOrderResponseClient';
import type { GetUserOperatorBranchesResponseOperator } from '../models/GetUserOperatorBranchesResponseOperator';
import type { GetWorkingBranchesAdminResponse } from '../models/GetWorkingBranchesAdminResponse';
import type { Language } from '../models/Language';
import type { ListOf1OfBranchUserSigmaDto } from '../models/ListOf1OfBranchUserSigmaDto';
import type { ListOf1OfCategoryAdminListedDto } from '../models/ListOf1OfCategoryAdminListedDto';
import type { OrderStatus } from '../models/OrderStatus';
import type { Pagination1OfBranchAdminListedDto } from '../models/Pagination1OfBranchAdminListedDto';
import type { Pagination1OfBranchClientDto } from '../models/Pagination1OfBranchClientDto';
import type { Pagination1OfBranchDisableLogAdminDto } from '../models/Pagination1OfBranchDisableLogAdminDto';
import type { Pagination1OfBranchSearchClientDto } from '../models/Pagination1OfBranchSearchClientDto';
import type { Pagination1OfBranchStatusLogAdminDto } from '../models/Pagination1OfBranchStatusLogAdminDto';
import type { PostBranchDisableReasonRequestAdmin } from '../models/PostBranchDisableReasonRequestAdmin';
import type { PostBranchRequestAdmin } from '../models/PostBranchRequestAdmin';
import type { PostPutGenericZohoValuesAdminRequest } from '../models/PostPutGenericZohoValuesAdminRequest';
import type { PutBranchBranchTagsRequestAdmin } from '../models/PutBranchBranchTagsRequestAdmin';
import type { PutBranchDistrictRequestAdmin } from '../models/PutBranchDistrictRequestAdmin';
import type { PutBranchRequestAdmin } from '../models/PutBranchRequestAdmin';
import type { PutBranchStatusResponse } from '../models/PutBranchStatusResponse';
import type { PutBranchStatusSigmaRequest } from '../models/PutBranchStatusSigmaRequest';
import type { PutBranchUsersRequestAdmin } from '../models/PutBranchUsersRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BranchesService {
    /**
     * @returns BranchClientDto OK
     * @throws ApiError
     */
    public static getBranchByIdPartner({
        id,
        userAddressId,
    }: {
        id: number,
        userAddressId: number,
    }): CancelablePromise<BranchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner/v1/branches/public/{id}',
            path: {
                'id': id,
            },
            query: {
                'userAddressId': userAddressId,
            },
        });
    }
    /**
     * @returns BranchClientDto OK
     * @throws ApiError
     */
    public static getBranchByIdPublicPartner({
        id,
        currentLocationLng,
        currentLocationLat,
        language,
    }: {
        id: number,
        currentLocationLng: number,
        currentLocationLat: number,
        language?: Language,
    }): CancelablePromise<BranchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner/v1/branches/public/public/{id}',
            path: {
                'id': id,
            },
            query: {
                'language': language,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchClientDto OK
     * @throws ApiError
     */
    public static postGetBranchesPartner({
        requestBody,
    }: {
        requestBody?: GetBranchesClientOptions,
    }): CancelablePromise<Pagination1OfBranchClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner/v1/branches/public/get-branches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchClientDto OK
     * @throws ApiError
     */
    public static postGetBranchesPublicPartner({
        requestBody,
    }: {
        requestBody?: GetBranchesClientPublicOptionsClient,
    }): CancelablePromise<Pagination1OfBranchClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/partner/v1/branches/public/public/get-branches',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Pagination1OfBranchSearchClientDto OK
     * @throws ApiError
     */
    public static getBranchesBySearchPartner({
        userAddressId,
        channelId,
        name,
        itemLimit,
        tagIds,
        page,
        limit,
    }: {
        userAddressId: number,
        channelId?: number,
        name?: string,
        itemLimit?: number,
        tagIds?: Array<number>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchSearchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner/v1/branches/public/search',
            query: {
                'userAddressId': userAddressId,
                'channelId': channelId,
                'name': name,
                'itemLimit': itemLimit,
                'tagIds': tagIds,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchSearchClientDto OK
     * @throws ApiError
     */
    public static getBranchesBySearchPublicPartner({
        currentLocationLng,
        currentLocationLat,
        language,
        name,
        itemLimit,
        channelId,
        tagIds,
        page,
        limit,
    }: {
        currentLocationLng: number,
        currentLocationLat: number,
        language?: Language,
        name?: string,
        itemLimit?: number,
        channelId?: number,
        tagIds?: Array<number>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchSearchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner/v1/branches/public/public/search',
            query: {
                'language': language,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
                'name': name,
                'itemLimit': itemLimit,
                'channelId': channelId,
                'tagIds': tagIds,
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * @returns GetMinimumCartAmountToOrderResponseClient OK
     * @throws ApiError
     */
    public static getMinimumCartAmountToOrderByBranchIdPartner({
        branchId,
        userAddressId,
    }: {
        branchId: number,
        userAddressId?: number,
    }): CancelablePromise<GetMinimumCartAmountToOrderResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/partner/v1/branches/public/public/{branchId}/minimum-cart-amount-to-order',
            path: {
                'branchId': branchId,
            },
            query: {
                'userAddressId': userAddressId,
            },
        });
    }
    /**
     * @returns GetBranchStatusResponse OK
     * @throws ApiError
     */
    public static getBranchStatusOperator({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<GetBranchStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/branches/status/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns PutBranchStatusResponse OK
     * @throws ApiError
     */
    public static putBranchStatusOperator({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PutBranchStatusSigmaRequest,
    }): CancelablePromise<PutBranchStatusResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/branches/status/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetBranchConfigurationsResponse OK
     * @throws ApiError
     */
    public static getBranchConfigurationsOperator({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<GetBranchConfigurationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/branches/configuration/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetUserOperatorBranchesResponseOperator OK
     * @throws ApiError
     */
    public static getUserOperatorBranchesOperator(): CancelablePromise<GetUserOperatorBranchesResponseOperator> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/branches',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns BranchDriverDto OK
     * @throws ApiError
     */
    public static getBranchDriver({
        id,
        language,
    }: {
        id: number,
        language?: Language,
    }): CancelablePromise<BranchDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/branches/{id}',
            path: {
                'id': id,
            },
            query: {
                'language': language,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns BranchClientDto OK
     * @throws ApiError
     */
    public static getBranchByIdClient({
        id,
        userAddressId,
    }: {
        id: number,
        userAddressId: number,
    }): CancelablePromise<BranchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/{id}',
            path: {
                'id': id,
            },
            query: {
                'userAddressId': userAddressId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetBranchShiftsClientResponse OK
     * @throws ApiError
     */
    public static getBranchShiftsClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetBranchShiftsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/{id}/schedule-shifts',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns BranchClientDto OK
     * @throws ApiError
     */
    public static getBranchByIdPublicClient({
        id,
        currentLocationLng,
        currentLocationLat,
        language,
    }: {
        id: number,
        currentLocationLng: number,
        currentLocationLat: number,
        language?: Language,
    }): CancelablePromise<BranchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/public/{id}',
            path: {
                'id': id,
            },
            query: {
                'language': language,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchClientDto OK
     * @throws ApiError
     */
    public static postGetBranchesClient({
        requestBody,
    }: {
        requestBody?: GetBranchesClientOptions,
    }): CancelablePromise<Pagination1OfBranchClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/branches/get-branches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchClientDto OK
     * @throws ApiError
     */
    public static postGetBranchesPublicClient({
        requestBody,
    }: {
        requestBody?: GetBranchesClientPublicOptionsClient,
    }): CancelablePromise<Pagination1OfBranchClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/branches/public/get-branches',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Pagination1OfBranchSearchClientDto OK
     * @throws ApiError
     */
    public static getBranchesBySearchClient({
        userAddressId,
        channelId,
        name,
        itemLimit,
        tagIds,
        page,
        limit,
    }: {
        userAddressId: number,
        channelId?: number,
        name?: string,
        itemLimit?: number,
        tagIds?: Array<number>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchSearchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/search',
            query: {
                'userAddressId': userAddressId,
                'channelId': channelId,
                'name': name,
                'itemLimit': itemLimit,
                'tagIds': tagIds,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfBranchSearchClientDto OK
     * @throws ApiError
     */
    public static getBranchesBySearchPublicClient({
        currentLocationLng,
        currentLocationLat,
        language,
        name,
        itemLimit,
        channelId,
        tagIds,
        page,
        limit,
    }: {
        currentLocationLng: number,
        currentLocationLat: number,
        language?: Language,
        name?: string,
        itemLimit?: number,
        channelId?: number,
        tagIds?: Array<number>,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchSearchClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/public/search',
            query: {
                'language': language,
                'currentLocationLng': currentLocationLng,
                'currentLocationLat': currentLocationLat,
                'name': name,
                'itemLimit': itemLimit,
                'channelId': channelId,
                'tagIds': tagIds,
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * @returns GetMinimumCartAmountToOrderResponseClient OK
     * @throws ApiError
     */
    public static getMinimumCartAmountToOrderByBranchIdClient({
        branchId,
        userAddressId,
    }: {
        branchId: number,
        userAddressId?: number,
    }): CancelablePromise<GetMinimumCartAmountToOrderResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/branches/public/{branchId}/minimum-cart-amount-to-order',
            path: {
                'branchId': branchId,
            },
            query: {
                'userAddressId': userAddressId,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns BranchAdminDto OK
     * @throws ApiError
     */
    public static getBranchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<BranchAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branches/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns BranchAdminDto OK
     * @throws ApiError
     */
    public static putBranchAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBranchRequestAdmin,
    }): CancelablePromise<BranchAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static postSubmitBranchToZohoAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches/{id}/submit-to-zoho',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static getBranchGenericZohoValuesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{id}/generic-zoho-values',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchZohoValues`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static putBranchGenericZohoValuesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutGenericZohoValuesAdminRequest,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{id}/generic-zoho-values',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCategories`
     * @returns ListOf1OfCategoryAdminListedDto OK
     * @throws ApiError
     */
    public static getBranchCategoriesAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<ListOf1OfCategoryAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{branchId}/categories',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns GetBranchDistrictsAdminResponse OK
     * @throws ApiError
     */
    public static getBranchDistrictsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetBranchDistrictsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{id}/districts',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDistricts`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchDistrictsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBranchDistrictRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{id}/districts',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranches`
     * @returns Pagination1OfBranchAdminListedDto OK
     * @throws ApiError
     */
    public static getBranchesAdmin({
        id,
        brandId,
        saleManId,
        userId,
        name,
        serviceId,
        channelIds,
        tagIds,
        manualStatus,
        disabled,
        searchWord,
        isVip,
        hasMyMealSupport,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        brandId?: number,
        saleManId?: number,
        userId?: string,
        name?: string,
        serviceId?: number,
        channelIds?: Array<number>,
        tagIds?: Array<number>,
        manualStatus?: BranchStatus,
        disabled?: boolean,
        searchWord?: string,
        isVip?: boolean,
        hasMyMealSupport?: boolean,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfBranchAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches',
            query: {
                'id': id,
                'brandId': brandId,
                'saleManId': saleManId,
                'userId': userId,
                'name': name,
                'serviceId': serviceId,
                'channelIds': channelIds,
                'tagIds': tagIds,
                'manualStatus': manualStatus,
                'disabled': disabled,
                'searchWord': searchWord,
                'isVIP': isVip,
                'hasMyMealSupport': hasMyMealSupport,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns BranchAdminDto OK
     * @throws ApiError
     */
    public static postBranchAdmin({
        requestBody,
    }: {
        requestBody?: PostBranchRequestAdmin,
    }): CancelablePromise<BranchAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchStatusLogs`
     * @returns Pagination1OfBranchStatusLogAdminDto OK
     * @throws ApiError
     */
    public static getBranchStatusLogsAdmin({
        id,
        page,
        limit,
    }: {
        id: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchStatusLogAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{id}/status-logs',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns Pagination1OfBranchDisableLogAdminDto OK
     * @throws ApiError
     */
    public static getBranchDisableLogsAdmin({
        id,
        page,
        limit,
    }: {
        id: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfBranchDisableLogAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{id}/disable-logs',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns ListOf1OfBranchUserSigmaDto OK
     * @throws ApiError
     */
    public static getBranchUsersAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<ListOf1OfBranchUserSigmaDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{branchId}/users',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchUsersAdmin({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PutBranchUsersRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{branchId}/users',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDetails`
     * @returns GetBranchBranchTagsAdminResponse OK
     * @throws ApiError
     */
    public static getBranchBranchTagsAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<GetBranchBranchTagsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/{branchId}/branch-tags',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchBranchTags`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchBranchTagsAdmin({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PutBranchBranchTagsRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{branchId}/branch-tags',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static postDisableBranchAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostBranchDisableReasonRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches/{id}/disable',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static postEnableBranchAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches/{id}/enable',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchVip`
     * @returns any OK
     * @throws ApiError
     */
    public static putBranchVipAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{id}/vip',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `SyncAlgoliaBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static syncBranchesAdmin(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches/sync',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns PutBranchStatusResponse OK
     * @throws ApiError
     */
    public static putBranchStatusAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBranchStatusSigmaRequest,
    }): CancelablePromise<PutBranchStatusResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/branches/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns GetWorkingBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getWorkingBranchesAdmin({
        regionIds,
        channelIds,
        orderStatuses,
    }: {
        regionIds: Array<number>,
        channelIds: Array<number>,
        orderStatuses?: Array<OrderStatus>,
    }): CancelablePromise<GetWorkingBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/working',
            query: {
                'regionIds': regionIds,
                'channelIds': channelIds,
                'orderStatuses': orderStatuses,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ExportBranchFiles`
     * @returns ExportAdminResponse OK
     * @throws ApiError
     */
    public static exportBranchesAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<ExportAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/export',
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ExportBranchFiles`
     * @returns ExportAdminResponse OK
     * @throws ApiError
     */
    public static exportBranchesLocalAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<ExportAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/branches/export-local',
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ImportBranchFiles`
     * @returns any OK
     * @throws ApiError
     */
    public static importBranchesAdmin({
        branchId,
        formData,
    }: {
        branchId: number,
        formData?: {
            file?: Blob;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/branches/{branchId}/import',
            path: {
                'branchId': branchId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranches`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBranchMenuAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/branches/{id}/menu',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
